import React from 'react';
import {Modal} from "@tag/tag-components-react-v4";
import AppRolesService from "../../General/services/AppRolesService";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";
import {ACPPTermination} from "../types/ACPPTermination";


function UnlockConfirmationModal(props: { visible: boolean, selectedTermination: ACPPTermination, handleClose: Function, handleUnlock: Function }) {
    
    const { accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    if (!AppRolesService.canUserSoftDeleteAcppEnvironments(accounts, isAuthenticated)) {
        throw new Error()
    }

    const renderModalContent = () => {
        let modalContent;
        
        modalContent = (
            <>
                Are you sure you wish to restore {props.selectedTermination.organisationName}?
            </>
        )

        return modalContent;
    }

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent='purple'
            heading={'Confirm'}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
            primaryButtonProps={{text: 'Confirm'}}
            onPrimaryButtonClick={() => props.handleUnlock()}
        >
            <div>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )

}

export default UnlockConfirmationModal;
